var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.031 4.938a2.377 2.377 0 0 1 2.375-2.375h1.188a2.377 2.377 0 0 1 2.375 2.374v.346c0 .727-.334 1.417-.91 1.866L7.266 9.346l-.452.356v2.36h2.375V10.86l2.341-1.84a4.752 4.752 0 0 0 1.815-3.737v-.346a4.75 4.75 0 0 0-4.75-4.75H7.406a4.75 4.75 0 0 0-4.75 4.75v.594h2.375v-.593Zm4.453 8.906H6.516v2.969h2.968v-2.97Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "question_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "question_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.063-1h11.874v19H2.063z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export default ForwardRef;